import HotelGallery from 'hotelGalleryUi/hotel-gallery-ui.js';
var initializeHotelGalleryUI = function () {
    typeof HotelGallery;
};
export default initializeHotelGalleryUI;
